import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageContentComponent } from './components/page-content/page-content.component';

const routes: Routes = [
  { path: '', redirectTo: '/introduction', pathMatch: 'full' },
  { path: 'introduction', component: PageContentComponent, data: { pageId: 'introduction' } },
  { path: 'benefits', component: PageContentComponent, data: { pageId: 'benefits' } },
  { path: 'eligibility', component: PageContentComponent, data: { pageId: 'eligibility' } },
  { path: 'gettingStarted', component: PageContentComponent, data: { pageId: 'gettingStarted' } },
  { path: 'dashboard', component: PageContentComponent, data: { pageId: 'dashboard' } },
  { path: 'createQuote', component: PageContentComponent, data: { pageId: 'createQuote' } },
  { path: 'completeApplication', component: PageContentComponent, data: { pageId: 'completeApplication' } },
  { path: 'initialScreen', component: PageContentComponent, data: { pageId: 'initialScreen' } },
  { path: 'additionalDetails', component: PageContentComponent, data: { pageId: 'additionalDetails' } },
  { path: 'questionnaires', component: PageContentComponent, data: { pageId: 'questionnaires' } },
  { path: 'requirements', component: PageContentComponent, data: { pageId: 'requirements' } },
  { path: 'finalScreen', component: PageContentComponent, data: { pageId: 'finalScreen' } },
  { path: 'reviewApplication', component: PageContentComponent, data: { pageId: 'reviewApplication' } },
  { path: 'eSignature', component: PageContentComponent, data: { pageId: 'eSignature' } },
  { path: 'manageESignature', component: PageContentComponent, data: { pageId: 'manageESignature' } },
  { path: 'submit', component: PageContentComponent, data: { pageId: 'submit' } },
  { path: 'needHelp', component: PageContentComponent, data: { pageId: 'needHelp' } },
  // Fallback route
  { path: '**', redirectTo: '/introduction' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64],
    bindToComponentInputs: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
